import { URL_PUBLIC, URL_SIGN_UP } from 'constants/urls'
import { GoToDictionary, GoToKey } from '@types'
/*
 When you need to redirect to a specific page based on a feature flag, you can use this dictionary
 you can use multiple experiment to the same redirect but the order of the dictionary will be the priority
*/

export const GO_TO_REDIRECT_DICTIONARY: GoToDictionary = {
  [GoToKey.WHATSAPP_BYPASS]: {
    default: {
      url: URL_PUBLIC,
    },
    // Adding a holder as example to show how to use the dictionary
    // [FeatureFlagValue.GATE_NAME]: '/ab-url-testing'
  },
  [GoToKey.COMPRATINO]: {
    default: {
      url: URL_PUBLIC,
    },
  },
  [GoToKey.SIGN_UP_V2]: {
    default: {
      url: URL_SIGN_UP,
    },
  },
}
